import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import JournalComponent from '../components/journal.component';
import { journals } from '../../../../../../redux/fms/journals/action';
import { selectJournalsQueryItems } from '../../../../../../redux/fms/journals/selector';
import { accountLedgers } from '../../../../../../redux/account-ledgers/action';
import { selectAccountLedgersListItems } from '../../../../../../redux/account-ledgers/selector';

const ManagementJournal = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const journalsQueryData = useSelector(selectJournalsQueryItems)
  const accountledgersItems = useSelector(selectAccountLedgersListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [selectedJournals, setSelectedJournals] = useState<any>([])

  const fetchJournalsQueryById = () => {
    dispatch(journals.query({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/journals/query`,
      entity: 'journals',
      jsonData:
      {
        Records: [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedJournals({ ...selectedJournals, [field]: event });
  }

  useEffect(() => {
      dispatch(accountLedgers.list({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-applications/accounts/ledgers/fetch`,
        entity: 'accountLedgers',
        jsonData: {}
      })).then(() => {
        if (parmas?.id > 0) {
          fetchJournalsQueryById()
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      })
    }, [])

  useEffect(() => {
    if (isQuery) {
      setSelectedJournals(journalsQueryData?.result?.items)
    }
  }, [isQuery])

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(journals.resetAction({ actionType: 'update' }))
      await dispatch(journals.update({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/journals`,
        entity: 'journals',
        jsonData:
        {
          Records: [
            {
              ...selectedJournals
            }
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(journals.resetAction({ actionType: 'create' }))
      await dispatch(journals.create({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/journals`,
        entity: 'journals',
        jsonData:
        {
          Records: [
            {
              ...selectedJournals
            }
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/e-applications/fms/journals')
  }

  return (
    <>
      {journalsQueryData?.isLoading ? <PageLoader /> :
        <JournalComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedJournals={selectedJournals}
          back={back}
          handleFormSubmit={handleFormSubmit}
          ledgersList={accountledgersItems?.result?.items}
        />
      }
    </>
  )
}

export default ManagementJournal;